import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { getEgColorChoiceRgba } from '@src/slide/infrastructure/module/independent/color/transform';

export class LinkUtils {
    private readonly defaultLinkColor = '#0563C1';

    public constructor(private uiDataService: IUiDataService, private selectionService?: ISelectionService) {}

    public getLinkThemeColor(slideNum: number | undefined) {
        let color = '';
        if (typeof slideNum === 'number') {
            const slideIndex = slideNum - 1;
            color = this.getLinkColor(this.uiDataService.presentation.children[slideIndex]);
        }
        return color || this.getCurrentSlideLinkThemeColor();
    }

    public getCurrentSlideLinkThemeColor() {
        return this.getLinkColor(this.selectionService?.currentSlide) || this.defaultLinkColor;
    }


    public getLinkColor(slide: ISlideModel | undefined) {
        if (slide?.sdkData) {
            const srgbClr = SlideDataServices.SDKDataServices.ColorManager()
                ?.getHLinkColor(slide.sdkData as any)?.srgbClr;
            return getEgColorChoiceRgba(srgbClr);
        }
        return slide?.props?.style?.linkColor?.srgb_color;
    }
}
